<div class="content-message-container">
    <div>
        <div>
            <div class="content-message {{ notificationInfo.type }}">
                <vn-icon size="16" class="notification-alignment {{ notificationInfo.iconColor }}" [name]="notificationInfo.icon" />
                @if (showCloseButton) {
                    <vn-icon class="button-alignment" name="theme-ex" size="12" (click)="onCloseClick()" />
                }
                <div class="page-matrix">
                    <div>
                        <div class="pc-text pc-component">
                            <span class="betslip-notification-title" *ngIf="!!notificationHeaderTitle"> {{ notificationHeaderTitle }} </span>
                            <section class="pc-richtext" *ngIf="message" [innerHTML]="message"></section>
                            <ng-content select="[message]" class="pc-richtext" />
                            @if (linkValues) {
                                <div class="link">
                                    <a [href]="linkValues.href" [attr.target]="linkValues.target" (click)="onLinkClick()">{{ linkValues.link }}</a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
